<template>
  <div class="view-leads inspection-collapse">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      >
      </vs-button>
      <div class="pr-4 justify-right">
        <h2 class="pl-2">{{ $t("labels.inspection") }}</h2>
      </div>
      <feather-icon
        :title="$t('labels.refresh')"
        icon="RefreshCwIcon"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        @click.prevent="getProject()"
      ></feather-icon>
    </div>
    <div class="inspect-question">
      <div>
        <view-project :project="project"></view-project>
      </div>
      <vx-card :title="$t('labels.select_consultant_service')">
        <div class="vx-row w-full m-0 mb-2">
          <div class="vx-col sm: w-full md:w-1/2 sm: p-0 md:pr-4">
            <label class>{{ $t("labels.consultant") }}</label>
            <v-select
              v-model="consultant"
              :options="consultants"
              :reduce="(consultants) => consultants.id"
              :value="$store.myValue"
              @input="setSelectedCon"
              label="name"
              name="consultants"
            />
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0 sm: p-0 md:pl-4"
          >
            <label class>{{ $t("labels.service") }}</label>
            <v-select
              v-model="service"
              :options="services_drop"
              :reduce="(services_drop) => services_drop.id"
              label="name"
              name="service"
              :value="$store.myValue"
              @input="setSelectedSer"
            />
          </div>
        </div>
      </vx-card>
      <div class="vx-row w-full mx-0" v-if="service">
        <div class="vx-col sm: w-full mt-6">
          <div class="vx-row mb-6">
            <div
              class="vx-col sm: w-full md:w-full label-center p-0 question-card"
            >
              <fullscreen
                ref="fullscreenExecutive"
                @change="fullscreenChangeExecutive()"
              >
                <vx-card
                  :title="$t('labels.executive_summary')"
                  class="mb-6 sub-cards user-listing"
                  v-if="
                    (selected_ser === 1 ||
                      selected_ser === 2 ||
                      selected_ser === 4) &&
                    executive_summary_data &&
                    renderComponent
                  "
                >
                  <div class="component-button-right">
                    <vs-button
                      class="float-right btn-add user-add-btn min-max-toggle"
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenExecutive ? 'icon-minimize' : 'icon-maximize'
                      "
                      @click="toggle('executive')"
                    ></vs-button>
                  </div>
                  <div v-if="change_component">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                        class="component-button-right"
                      >
                        <executive-summary
                          :fullscreen-executive="fullscreenExecutive"
                          :executive-data="executive_summary_data"
                          :project-id="this.$route.params.id"
                          :consultant-id="selected_con"
                          :service-id="selected_ser"
                        ></executive-summary>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                  <div v-if="!change_component">
                    <vs-collapse>
                      <vs-collapse-item
                        icon-pack="feather"
                        icon-arrow="icon-arrow-down"
                        class="component-button-right"
                      >
                        <executive-summary-max
                          :executive-data="executive_summary_data"
                          :project-id="this.$route.params.id"
                          :consultant-id="selected_con"
                          :service-id="selected_ser"
                        >
                        </executive-summary-max>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenVessel"
                @change="fullscreenChangeVessel"
              >
                <vx-card
                  :title="$t('labels.vessel_assessment')"
                  class="mb-6 sub-cards user-listing"
                  v-if="selected_ser === 1"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="
                        fullscreenVessel ? 'icon-minimize' : 'icon-maximize'
                      "
                      @click="toggle('vessel')"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <vessel-assessment
                        :consultant-id="selected_con"
                      ></vessel-assessment>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenGeneralInfo"
                @change="fullscreenChangeGeneralInfo"
              >
                <vx-card
                  :title="$t('labels.general_information')"
                  class="mb-6 sub-cards user-listing"
                  v-if="selected_ser === 1"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenGeneralInfo
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('generalInfo')"
                      class="float-right btn-add user-add-btn min-max-toggle"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <general-information
                        :consultant-id="selected_con"
                        :fullscreen-general-info="fullscreenGeneralInfo"
                      ></general-information>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenGeneralImage"
                @change="fullscreenChangeGeneralImage"
              >
                <vx-card
                  class="mb-6 sub-cards user-listing"
                  :title="$t('labels.general_images')"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      :icon="
                        fullscreenGeneralImage
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('generalImage')"
                      class="float-right btn-add user-add-btn min-max-toggle"
                    >
                    </vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <general-image-upload
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                      >
                      </general-image-upload>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen ref="fullscreen" @change="fullscreenChange">
                <vx-card
                  :title="$t('labels.qualification_of_officers')"
                  class="mb-6 sub-cards"
                  v-if="selected_ser === 1 || selected_ser === 2"
                >
                  <div class="component-button-right">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="fullscreen ? 'icon-minimize' : 'icon-maximize'"
                      @click="toggle('officer')"
                    ></vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <qualification-officers-details
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                      >
                      </qualification-officers-details>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>

              <fullscreen
                ref="fullscreenMiscellaneous"
                @change="fullscreenChangeMiscellaneous"
              >
                <vx-card
                  :title="$t('labels.miscellaneous')"
                  class="mb-6 sub-cards miscellaneous"
                  v-if="
                    (selected_ser === 4 ||
                      selected_ser === 2 ||
                      selected_ser === 1) &&
                    renderComponentMis
                  "
                >
                  <div style="position: absolute; right: 72px; top: 3px">
                    <vs-button
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      class="float-right btn-add user-add-btn min-max-toggle"
                      :icon="
                        fullscreenMiscellaneous
                          ? 'icon-minimize'
                          : 'icon-maximize'
                      "
                      @click="toggle('miscellaneous')"
                    ></vs-button>
                  </div>
                  <vs-collapse>
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right"
                    >
                      <miscellaneous
                        :consultant-id="selected_con"
                        :service-id="selected_ser"
                        :executive-data="executive_summary_data"
                      ></miscellaneous>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </fullscreen>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 md:float-right sm: block md:flex">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-printer"
              @click="printQuestions()"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.print_questions") }}</vs-button
            >
            <vs-button
              color="dark"
              type="filled"
              icon-pack="feather"
              icon="icon-printer"
              @click="printQuestions(1)"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.print_questions_with_guidance") }}</vs-button
            >
            <vs-button
              color="warning"
              type="filled"
              icon-pack="feather"
              icon="icon-filter"
              @click="showfilter = !showfilter"
              v-show="this.service"
              class="mr-2 sm: mt-4 md:0 btn-color"
              >{{ $t("labels.filter") }}</vs-button
            >
          </div>
        </div>
      </div>

      <vx-card class="filter_card mt-4" v-show="showfilter == true">
        <div class="vx-row filter-default">
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.section") }}</label>
            <v-select
              v-model="section"
              :options="filterSection"
              :reduce="(filterSection) => filterSection.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.designation") }}</label>
            <v-select
              v-model="designation"
              :options="filterDesignation"
              :reduce="(filterDesignation) => filterDesignation.id"
              label="name"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3">
            <label class="pl-1">{{ $t("labels.query_status") }}</label>
            <v-select
              v-model="query_status_filter"
              :options="filterQueryStatus"
              :reduce="(filterQueryStatus) => filterQueryStatus.value"
              label="label"
              class="filter-dropdown"
            />
          </div>
          <div class="vx-col sm: w-full md:w-2/3">
            <label class="pl-1">{{ $t("labels.search") }}</label>
            <!-- <v-select multiple taggable v-model="search" class="w-full" /> -->
            <vs-input
              icon-pack="feather"
              icon="icon-search"
              v-model="search"
              class="w-full"
            />
          </div>
          <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
            <vs-button
              color="maroon"
              type="filled"
              icon-pack="feather"
              icon="icon-x"
              :title="$t('labels.filter')"
              @click="clearFilter()"
              :disabled="
                !this.section &&
                !this.designation &&
                !this.query_status_filter &&
                !this.search
              "
              class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
              >{{ $t("labels.clear") }}</vs-button
            >
          </div>
        </div>
      </vx-card>

      <!-- pagination start-->

      <div
        class="mt-6 question-pagination"
        v-if="service && question_length >= 1"
      >
        <div class="vx-row">
          <div
            class="vx-col sm: w-full md:w-1/2 sm: order-2 md:order-1 sm: mt-4 md:mt-0"
          >
            <vs-chip color="primary" class="mt-2 ml-1"
              >{{ start + 1 }} -
              {{ end > question_length ? question_length : end }} of
              {{ question_length }}</vs-chip
            >
          </div>
          <div
            class="vx-col sm: w-full md:w-1/2 sm: order-1 md:order-2 inspection-pagination"
          >
            <vs-pagination
              color="dark"
              :total="pageCount"
              v-model="currentx"
              class="mb-1"
            ></vs-pagination>
          </div>
        </div>
      </div>

      <!-- pagination end -->

      <div class="vx-row w-full mx-0" v-if="service">
        <div class="vx-col sm: w-full mt-6">
          <div class="vx-row mb-6">
            <div
              class="vx-col sm: w-full md:w-full label-center p-0 question-list question-card"
            >
              <div
                v-for="(question, qindex) in filtered_questions"
                :key="qindex"
              >
                <vx-card
                  :title="
                    question.section_reference_number +
                    ' - ' +
                    question.question
                  "
                  class="mb-6 sub-cards"
                >
                  <vs-collapse id="main-collpase">
                    <vs-collapse-item
                      icon-pack="feather"
                      icon-arrow="icon-arrow-down"
                      class="component-button-right question-collapse"
                    >
                      For consultant

                      <vx-card class="add-query">
                        <div class="query-text flex justify-between">
                          <feather-icon
                            :title="$t('labels.go_to_question_page')"
                            icon="ExternalLinkIcon"
                            class="cursor-pointer mb-6 mt-6 external-link"
                            @click="
                              $router.push({
                                name: 'Question',
                                params: {
                                  id: question
                                    .project_consultant_service_question.id,
                                },
                              })
                            "
                          >
                          </feather-icon>
                          <span
                            class="query-text-label"
                            v-if="
                              question.project_consultant_service_question
                                .query_text
                            "
                          >
                            <label
                              >{{ $t("labels.query_by_reviewer") }} :</label
                            >
                            <span>{{
                              question.project_consultant_service_question
                                .query_text
                            }}</span>
                          </span>
                          <div
                            class="query-status"
                            v-if="
                              question.project_consultant_service_question
                                .query_status !== 'N'
                            "
                          >
                            <span
                              :title="$t('labels.query_status')"
                              color="primary"
                              class="ml-1"
                              >{{
                                question.project_consultant_service_question
                                  .query_status_name
                              }}</span
                            >
                          </div>
                        </div>
                        <div class="chat-inspection justify-center mb-6">
                          <div class="md:flex text-center chat-btns">
                            <vs-button
                              @click="getComments(qindex)"
                              color="dark"
                              type="border"
                              class="sm: mb-5 md:mb-0"
                            >
                              {{ $t("labels.chat") }}</vs-button
                            >
                            <div
                              v-if="
                                question.project_consultant_service_question
                                  .query_status !== 'R' &&
                                $store.state.userInfo.type == 'A'
                              "
                              class
                            >
                              <vs-button
                                @click="
                                  openPopupForRaisedQuery(
                                    question.project_consultant_service_question
                                      .id
                                  )
                                "
                                class="md:ml-4"
                                color="warning"
                                value="R"
                                type="border"
                                >{{ $t("labels.raise_query") }}
                              </vs-button>
                            </div>
                            <div
                              class="text-center"
                              v-if="
                                ['R', 'A'].includes(
                                  question.project_consultant_service_question
                                    .query_status
                                ) && $store.state.userInfo.type == 'A'
                              "
                            >
                              <vs-button
                                @click="
                                  getProjectChangeQueryStatus(
                                    question.project_consultant_service_question
                                      .id,
                                    'MR'
                                  )
                                "
                                class="md:ml-4"
                                color="primary"
                                value="MR"
                                type="border"
                                >{{ $t("labels.mark_as_resolved") }}</vs-button
                              >
                            </div>
                            <div
                              v-if="
                                question.project_consultant_service_question
                                  .query_status === 'R' &&
                                $store.state.userInfo.type == 'CN'
                              "
                              class="text-center"
                            >
                              <vs-button
                                @click="
                                  getProjectChangeQueryStatus(
                                    question.project_consultant_service_question
                                      .id,
                                    'A'
                                  )
                                "
                                class="md:ml-4"
                                color="warning"
                                value="A"
                                type="border"
                                >{{ $t("labels.query_answered") }}</vs-button
                              >
                            </div>
                          </div>
                        </div>
                      </vx-card>

                      For consultant end

                      <div
                        class="mt-6"
                        v-if="question.all_vessel_types && question.guidance"
                      >
                        <div class="mb-2">
                          <label>{{ $t("labels.vessel_type_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{
                          question.guidance
                        }}</label>
                      </div>
                      <div
                        class="mt-6 mb-4"
                        v-if="!question.all_vessel_types && question.guidance"
                      >
                        <div class="mb-2">
                          <label>{{ $t("labels.vessel_type_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{
                          question.guidance
                        }}</label>
                      </div>
                      <div
                        class="mt-2"
                        v-if="!question.all_flags && question.flag_text != null"
                      >
                        <div class="mb-2">
                          <label>{{ $t("labels.flag_guidance") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{
                          question.flag_text
                        }}</label>
                      </div>
                      <div class="mt-2" v-if="question.regulation_reference">
                        <div class="mb-2">
                          <label>{{ $t("labels.regulation_reference") }}</label>
                        </div>
                        <label class="p-4 text-lg font-light">{{
                          question.regulation_reference
                        }}</label>
                      </div>
                      <div class="vx-row mt-4">
                        <div class="vx-col sm: w-full md:w-1/2">
                          <label class="bold-fields">{{
                            $t("labels.images")
                          }}</label>
                          <vue-upload-multiple-image
                            :popupText="$t('labels.guidance_images')"
                            :dragText="$t('labels.browse_images')"
                            :ref="
                              'multiple_image_' +
                              question.project_consultant_service_question.id
                            "
                            primaryText
                            browseText
                            markIsPrimaryText
                            accept="image/jpeg, image/png, image/jpg"
                            @upload-success="uploadImageSuccess"
                            @before-remove="beforeRemove"
                            :data-images="
                              question.project_consultant_service_question
                                .images
                            "
                            :maxImage="100"
                            class="w-full mb-2 mt-1 guidance-image"
                            :idUpload="'image-upload' + qindex"
                            name="image_upload"
                          ></vue-upload-multiple-image>
                        </div>
                        <div class="vx-col sm: w-full md:w-1/2">
                          <div class="vx-row">
                            <div class="vx-col w-full pr-4 sm: mt-6 md:mt-0">
                              <label class>{{ $t("labels.defect") }}</label>
                              <v-select
                                v-model="
                                  question.project_consultant_service_question
                                    .defect_id
                                "
                                :options="
                                  question.project_consultant_service_question
                                    .defects
                                "
                                :reduce="(defects) => parseInt(defects.id)"
                                label="name"
                                name="defects"
                                v-validate="'required'"
                                :input-changed="() => detectChange()"
                              />
                              <span class="text-danger text-sm">{{
                                errors.first("defects")
                              }}</span>
                            </div>
                            <div class="vx-col w-full mt-6">
                              <label class>{{ $t("labels.answer") }}</label>
                              <vs-textarea
                                type="text"
                                height="105"
                                class="w-full mb-0 mt-1"
                                name="answer_text"
                                :id="'answer-text' + qindex"
                                maxlength="5000"
                                v-model="
                                  question.project_consultant_service_question
                                    .answer_text
                                "
                                :placeholder="$t('labels.write_answer')"
                                icon-no-border
                                v-validate="'required'"
                                @keydown="() => detectChange()"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="vx-col sm: w-full mt-6">
                          <div class="vx-row w-full m-0">
                            <label class>{{ $t("labels.audio_file") }}</label>
                            <div
                              class="w-full sm: block md:flex"
                              v-if="
                                !question.project_consultant_service_question
                                  .answer_attachment
                              "
                            >
                              <div class="vx-col sm: w-full md:w-1/2 mt-1">
                                <input
                                  type="file"
                                  :name="
                                    question.project_consultant_service_question
                                      .answer_attachment
                                  "
                                  accept=".mp3"
                                  id="answer_attachment"
                                  class="mt-1"
                                  v-on:change="handleFiles($event, qindex)"
                                />
                                <label for="answer_attachment" class="btn-1"
                                  >Upload</label
                                >
                              </div>
                              <div
                                class="vx-col sm: w-full md:w-1/2 mt-1"
                                v-if="
                                  question.project_consultant_service_question
                                    .answer_attachment
                                "
                              >
                                <audio controls :id="'audio_control' + qindex">
                                  <source
                                    :src="
                                      question
                                        .project_consultant_service_question
                                        .answer_attachment
                                    "
                                    type="audio/mpeg"
                                    :id="'audio_source' + qindex"
                                  />
                                </audio>
                              </div>
                            </div>
                            <div
                              class="w-full sm: block md:flex audio-file"
                              v-else
                            >
                              <div class="vx-col sm: w-full md:w-1/2 mt-1 flex">
                                <p
                                  class="self-center audio sm: mb-0"
                                  id="audio_name"
                                >
                                  {{
                                    getFileName(
                                      question
                                        .project_consultant_service_question
                                        .answer_attachment
                                    )
                                  }}
                                </p>
                                <vs-button
                                  color="danger"
                                  type="flat"
                                  class="mr-1 mt-1 float-right ml-2"
                                  icon-pack="feather"
                                  icon="icon-x"
                                  v-model="cancel"
                                  @click.prevent="clearFileName(qindex)"
                                ></vs-button>
                              </div>
                              <div
                                class="vx-col sm: w-full md:w-1/2"
                                v-if="
                                  question.project_consultant_service_question
                                    .answer_attachment
                                "
                              >
                                <audio
                                  controls
                                  :id="'audio_control_exit' + qindex"
                                >
                                  <source
                                    :src="
                                      question
                                        .project_consultant_service_question
                                        .answer_attachment
                                    "
                                    type="audio/mpeg"
                                    :id="'audio_source' + qindex"
                                  />
                                </audio>
                              </div>
                            </div>
                            <div
                              class="w-full flex justify-end"
                              v-if="
                                question.project_consultant_service_question
                                  .answer_text != null
                              "
                            >
                              <label
                                :class="
                                  question.project_consultant_service_question
                                    .is_corrected
                                    ? 'text-primary'
                                    : 'text-danger'
                                "
                                >{{
                                  question.project_consultant_service_question
                                    .is_corrected
                                    ? "Marked as Correct"
                                    : "Marked as Incorrect"
                                }}</label
                              >
                              <vs-switch
                                :value="qindex"
                                :id="'is_corrected' + qindex"
                                v-model="
                                  question.project_consultant_service_question
                                    .is_corrected
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col sm: w-full mb-4 mt-6">
                          <vs-button
                            class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn float-right"
                            color="dark"
                            :disabled="button_loading"
                            id="save-answer"
                            button="submit"
                            @click.prevent="
                              sendData(
                                question.project_consultant_service_question,
                                question
                              )
                            "
                            >{{ $t("labels.save_answer") }}</vs-button
                          >
                        </div>
                      </div>
                    </vs-collapse-item>
                  </vs-collapse>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
        <vs-popup
          class="holamundo"
          :title="$t('labels.raising_query')"
          :active.sync="popupActiveRaiseQuery"
        >
          <div class="vx-row">
            <div class="vx-col md:w-1/7">
              <vs-avatar
                :text="this.$store.state.userInfo.name"
                color="dark"
                size="40px"
                text-color="white"
              />
            </div>
            <div class="vx-col md:w-10/12">
              <vs-textarea
                type="text"
                class="w-full mb-0 mt-1"
                name="query_text"
                id="query_text"
                maxlength="5000"
                v-model="query_text"
                :placeholder="$t('labels.type_your_query')"
                icon-no-border
              />
            </div>
          </div>
          <div class="mt-6 submit-btn">
            <vs-button
              class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
              color="primary"
              :disabled="button_loading"
              id="save-answer"
              button="submit"
              @click="submitQueryText()"
              >{{ $t("labels.submit") }}</vs-button
            >
          </div>
        </vs-popup>
      </div>
      <vs-popup
        class="holamundo"
        :title="$t('labels.chat')"
        :active.sync="popupActive"
      >
        <div>
          <div
            class="vx-row"
            v-for="(comment, cindex) in comments"
            :key="cindex"
          >
            <div class="vx-col w-1/7">
              <vs-avatar
                :text="comment.user.name"
                color="dark"
                size="40px"
                text-color="white"
              />
            </div>
            <div class="vx-col sm: w-8/12 md:w-10/12 label-center">
              <label class="comment-avatar">{{ comment.comment }}</label>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-1/7">
            <vs-avatar
              :text="this.$store.state.userInfo.name"
              color="dark"
              size="40px"
              text-color="white"
            />
          </div>
          <div class="vx-col sm: w-8/12 md:w-10/12">
            <vs-textarea
              type="text"
              class="w-full mb-0 mt-1"
              name="comment"
              id="comment"
              maxlength="5000"
              v-model="comment"
              :placeholder="$t('labels.type_message')"
              icon-no-border
            />
          </div>
        </div>
        <div class="mt-6 submit-btn">
          <vs-button
            class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
            color="primary"
            :disabled="button_loading"
            id="save-answer"
            button="submit"
            @click="addProjectQuestionComments()"
            >{{ $t("labels.submit") }}</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        :title="$t('labels.raising_query')"
        :active.sync="popupActiveRaiseQuery"
      >
        <div class="vx-row">
          <div class="vx-col w-1/7">
            <vs-avatar
              :text="this.$store.state.userInfo.name"
              color="dark"
              size="40px"
              text-color="white"
            />
          </div>
          <div class="vx-col w-10/12">
            <vs-textarea
              type="text"
              class="w-full mb-0 mt-1"
              name="query_text"
              id="query_text"
              maxlength="5000"
              v-model="query_text"
              :placeholder="$t('labels.type_your_query')"
              icon-no-border
            />
          </div>
        </div>
        <div class="mt-6 submit-btn">
          <vs-button
            class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
            color="primary"
            :disabled="button_loading"
            id="save-answer"
            button="submit"
            @click="submitQueryText()"
            >{{ $t("labels.submit") }}</vs-button
          >
        </div>
      </vs-popup>

      <!-- new code added for demo tree structure -->
    </div>
    <div class="vx-col sm: w-full mb-4 mt-6" v-if="service">
      <vs-button
        class="vs-component vs-button md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn save-all-btn float-right z-10"
        color="warning"
        :disabled="button_loading"
        id="save-answer"
        @click.prevent="sendAllData"
        >{{ $t("labels.save_all_answer") }}</vs-button
      >
    </div>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import ViewProject from "@/layouts/components/projects/view-project.vue";
import GeneralImageUpload from "@/layouts/components/projects/general-images-upload.vue";
import QualificationOfficersDetails from "@/layouts/components/projects/qualification-officers-details";
import VesselAssessment from "@/layouts/components/projects/vessel-assessment";
import Miscellaneous from "@/layouts/components/projects/miscellaneous";
import ExecutiveSummary from "@/layouts/components/projects/executive-summary";
import GeneralInformation from "@/layouts/components/projects/general-information";
import vSelect from "vue-select";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
import ExecutiveSummaryMax from "@/layouts/components/projects/executive-summary-max";
import { TreeView } from "@progress/kendo-treeview-vue-wrapper";
Vue.use(fullscreen);
export default {
  data() {
    return {
      isDropped: false,
      isActive1: false,
      isActive2: false,
      isActive3: false,
      active: true,
      forChat: false,
      renderComponent: true,
      renderComponentMis: true,
      answer_text: "",
      is_corrected: false,
      cancel: "",
      images: [],
      service: null,
      services_drop: [],
      consultant: "",
      consultants_drop: [],
      consultants: [],
      questions: "",
      question: [],
      consultant_services_array: [],
      question_drop: [],
      service_ids: "",
      id: this.$route.params.id,
      model: "project",
      defects: [],
      defect_id: null,
      defects_drop: [],
      selected_con: "",
      selected_ser: "",
      comments: [],
      comment: "",
      popupActive: false,
      popupActiveRaiseQuery: false,
      query_text: "",
      targeted_question_id: null,
      selected_question_index: null,
      raw_consultants: [],
      project: {},
      currentx: 1, // current page
      question_length: 0, // length of all questions
      perPage: 10, // perPage
      start: 1,
      end: 10,
      all_vessel_types: "",
      showfilter: false,
      search: "",
      designation: "",
      section_reference_number: null,
      section: 0,
      query_status_filter: "",
      filterSection: [{ name: "All Section", id: 0 }],
      filterDesignation: [{ name: "All Designation", id: "" }],
      filterQueryStatus: [
        { label: "All Query", value: "" },
        { label: "No Query", value: "N" },
        { label: "Query Reolved", value: "MR" },
        { label: "Query Raised", value: "R" },
        { label: "Query Answered", value: "A" },
      ],
      executive_summary_data: "",
      isChanged: false,
      fullscreen: false,
      fullscreenExecutive: false,
      fullscreenVessel: false,
      fullscreenGeneralInfo: false,
      fullscreenGeneralImage: false,
      fullscreenMiscellaneous: false,
      change_component: true,
      activeslider: "questionairy",
      question_section: "",
    };
  },
  components: {
    ExecutiveSummaryMax,
    VueUploadMultipleImage,
    ViewProject,
    GeneralImageUpload,
    "v-select": vSelect,
    QualificationOfficersDetails,
    Miscellaneous,
    GeneralInformation,
    ExecutiveSummary,
    VesselAssessment,
    treeview: TreeView,
  },
  watch: {
    selected_con(val) {
      // if con drop is cleared than clear service and its drop
      if (!val) {
        this.service = null;
        this.services_drop = [];
      }
    },
  },
  computed: {
    filtered_questions() {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];
      let question = [];
      let that = this;

      that.executive_summary_data = "";
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          if (ser_target === 1) {
            that.executive_summary_data =
              el.project_consultant.safety_inspection_executive_summary_template;
          }
          if (ser_target === 2) {
            that.executive_summary_data =
              el.project_consultant.navigation_assessment_executive_summary_template;
          }
          if (ser_target === 3) {
            that.executive_summary_data =
              el.project_consultant.internal_audit_executive_summary_template;
          }
          if (ser_target === 4) {
            that.executive_summary_data =
              el.project_consultant.visit_report_executive_summary_template;
          }
          if (ser_target === 5) {
            that.executive_summary_data =
              el.project_consultant.technical_inspection_executive_summary_template;
          }
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              question = el.project_consultant_service.questions;
              question.forEach(function (item, index) {
                if (ser_target === 1) {
                  if (item.section_id !== 1) {
                    questions.push(item);
                  }
                } else {
                  questions = question;
                }
              });
              //start filter process
              if (
                that.designation ||
                that.section ||
                that.query_status_filter ||
                that.search
              ) {
                if (questions.length > 0) {
                  that.currentx = 1;
                  questions = questions.filter(function (que) {
                    let designationFlag = false;
                    let sectionFlag = false;
                    let statusFlag = false;
                    let searchFlag = false;
                    if (que.all_designations || !that.designation)
                      designationFlag = true;
                    else
                      que.designations.forEach(function (d) {
                        if (d.id == that.designation) designationFlag = true;
                      });

                    if (
                      que.section_id == that.section ||
                      que.sub_section_id == that.section ||
                      !that.section
                    )
                      sectionFlag = true;
                    if (
                      que.project_consultant_service_question.query_status ==
                        that.query_status_filter ||
                      !that.query_status_filter
                    )
                      statusFlag = true;
                    if (
                      !that.search ||
                      that.hsearch(que.question) ||
                      que.section_reference_number
                        .toLowerCase()
                        .includes(that.search)
                    )
                      searchFlag = true;

                    return (
                      designationFlag && sectionFlag && statusFlag && searchFlag
                    );
                  });
                }
              }
              questions.forEach(function (que) {
                // Display vessel_types guidance
                that.type_id = that.project.vessel_type_id;
                that.sub_type_id = that.project.vessel_sub_type_id;
                if (!que.all_vessel_types) {
                  let vessel_types = que.vessel_types;

                  vessel_types.forEach((element) => {
                    let que_vessel_type =
                      element.question_vessel_type.vessel_type_id;

                    if (que_vessel_type === that.type_id) {
                      let vessel_sub_types =
                        element.question_vessel_type.vessel_sub_types;

                      vessel_sub_types.forEach((ele) => {
                        let que_subvessel_type = ele.id;
                        if (que_subvessel_type === that.sub_type_id) {
                          que.guidance = element.question_vessel_type.guidance;
                          return;
                        }
                      });
                    }
                  });
                } else {
                  que.guidance = que.vessel_type_guidance;
                }
              });

              questions.forEach(function (que) {
                // Display flag guidance
                let flag_id = that.project.vessel.flag_id;
                if (!que.all_flags) {
                  let flags = que.flags;
                  flags.forEach((element) => {
                    let que_flag = element.id;

                    if (que_flag === flag_id) {
                      que.flag_text = que.flag_guidance;
                      return;
                    }
                  });
                  return;
                }
              });
            }

            that.question_length = questions.length;
          });
        }
      });

      /**
      Main Pagination Logic
      start = currentpage - 1 * perpage
       */
      this.start = (this.currentx - 1) * this.perPage;
      this.end = this.start + this.perPage;
      return questions.slice(this.start, this.end);
    },
    pageCount() {
      let l = this.question_length,
        s = this.perPage;
      return Math.ceil(l / s);
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  mounted() {
    this.executive_summary_data = "";
    this.getProject();
    this.getDesignations();
    this.getSections();
    this.getQuestions();
    this.collapse();
    this.getSubSection();
  },
  methods: {
    open() {
      console.log("inner question");
    },
    async getQuestions() {
      let resposne = await this.getHTTPPostResponse(
        "questions/treeview/section-list"
      );
      if (resposne) {
        this.question_section = resposne.data.sections;
        console.log(this.question_section);
      }
    },
    async getSubSection() {
      let input = {
        section_id: 2,
        consultant_id: 3,
        project_id: "1",
        service_id: 1,
        sub_section_id: 3,
      };
      let resposne = await this.getHTTPPostResponse(
        "questions/treeview/question-list",
        input
      );
      if (resposne) {
        console.log(resposne.data);
      }
    },
    collapse() {
      const details = document.querySelectorAll("details");
      details.forEach((targetDetail) => {
        // targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
        // });
      });
      (this.isActive1 = false),
        (this.isActive2 = false),
        (this.isActive3 = false),
        (this.forChat = false);
    },
    change(num) {
      if (num == 1) {
        this.isActive1 = true;
        this.isActive2 = false;
        this.isActive3 = false;
        this.forChat = false;
      } else if (num == 2) {
        this.isActive2 = true;
        this.isActive1 = false;
        this.isActive3 = false;
        this.forChat = false;
      } else if (num == 3) {
        this.isActive3 = true;
        this.isActive1 = false;
        this.isActive2 = false;
        this.forChat = false;
      } else if (num == 0) {
        this.isActive1 = false;
        this.isActive2 = false;
        this.isActive3 = false;
        this.forChat = false;
      }
      console.log("changes");
    },
    defect() {
      this.forChat = true;
      (this.isActive1 = false),
        (this.isActive2 = false),
        (this.isActive3 = false);
    },
    toggle(type) {
      if (type == "executive") {
        this.$refs.fullscreenExecutive.toggle();
        this.change_component = !this.change_component;
      }
      if (type == "vessel") {
        this.$refs.fullscreenVessel.toggle();
      }
      if (type == "generalInfo") {
        this.$refs.fullscreenGeneralInfo.toggle();
      }
      if (type == "officer") {
        this.$refs.fullscreen.toggle();
      }
      if (type == "generalImage") {
        this.$refs.fullscreenGeneralImage.toggle();
      }
      if (type == "miscellaneous") {
        this.$refs.fullscreenMiscellaneous.toggle();
      }
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    fullscreenChangeExecutive(fullscreen) {
      this.fullscreenExecutive = fullscreen;
    },
    fullscreenChangeVessel(fullscreen) {
      this.fullscreenVessel = fullscreen;
    },
    fullscreenChangeGeneralInfo(fullscreen) {
      this.fullscreenGeneralInfo = fullscreen;
    },
    fullscreenChangeGeneralImage(fullscreen) {
      this.fullscreenGeneralImage = fullscreen;
    },
    fullscreenChangeMiscellaneous(fullscreen) {
      this.fullscreenMiscellaneous = fullscreen;
    },
    hsearch(question) {
      let tags = this.search.toLowerCase().split(" ");

      let que = question.toLowerCase();

      let flag = false;
      for (let i = 0; i < tags.length; i++) {
        if (que.includes(tags[i])) {
          flag = true;
          break;
        }
      }
      return flag;
    },
    openPopupForRaisedQuery(id) {
      this.targeted_question_id = id;
      this.popupActiveRaiseQuery = true;
    },

    async submitQueryText() {
      let input = {
        project_consultant_service_question_id: this.targeted_question_id,
        status: "R",
        query_text: this.query_text,
      };

      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.popupActiveRaiseQuery = false;
        this.query_text = "";
        this.getProject();
      }
    },

    /**
     * @function setSelectedCon
     * @description this function will invoke whenever v-select of consultans changes value
     */
    setSelectedCon(value) {
      //fist clear selected service and its dropdown array
      this.service = null;
      this.services_drop = [];
      //set current v -select value as a selected_con
      this.selected_con = value;

      // get services for selected cont
      let consultants = this.raw_consultants;
      var selectedCon = consultants.filter(function (el) {
        return el.id == value;
      });
      let service_req = selectedCon[0].project_consultant.services;
      let filteredServices = [];
      for (var i = 0; i < service_req.length; i++) {
        let obj = { id: service_req[i].id, name: service_req[i].name };
        filteredServices.push(obj);
      }
      this.services_drop = filteredServices;
    },
    setSelectedSer(value) {
      this.selected_ser = value;
      this.renderComponent = false;
      this.renderComponentMis = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
        this.renderComponentMis = true;
      });
      this.executive_summary_data = "";
    },
    async sendAllData() {
      let is_error = false;
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      let questions = [];

      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              questions = el.project_consultant_service.questions;
            }
          });
        }
      });

      let input = {
        answers: [],
      };

      // let questions = this.questions;
      questions.forEach((question) => {
        let data = question.project_consultant_service_question;
        var images;
        var name = "multiple_image_" + data.id;
        if (this.$refs[name] && this.$refs[name].length) {
          images = this.$refs[name][0].images;
        } else {
          images = data.images;
        }

        var images_url = images.map((image) => {
          return image.s3_url;
        });
        var answer = {
          project_consultant_service_question_id: data.id,
          defect_id: data.defect_id,
          answer_text: data.answer_text,
          answer_attachment: data.answer_attachment,
          images: images_url,
          is_corrected: data.is_corrected,
        };

        if (answer.defect_id || answer.answer_text) {
          if (answer.defect_id && answer.answer_text) {
            input.answers.push(answer);
          } else {
            is_error = true;
            this.displayError(
              "Please fill required details: Question No. " +
                question.question_number +
                "-" +
                question.question +
                "details"
            );
          }
        }
      });
      if (input.answers.length > 0 && is_error == false) {
        this.recordInspection(input);
      }
    },
    async recordInspection(input) {
      let url = "/projects/inspection/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#save-answer",
        true
      );
      if (response) {
        this.getProject();
      }
    },
    async sendData(data, question_details) {
      var name = "multiple_image_" + data.id;
      var images = this.$refs[name][0].images;
      var images_url = images.map((image) => {
        return image.s3_url;
      });
      var answer = {
        project_consultant_service_question_id: data.id,
        defect_id: data.defect_id,
        answer_text: data.answer_text,
        answer_attachment: data.answer_attachment,
        images: images_url,
        is_corrected: data.is_corrected,
      };
      let input = {
        answers: [],
      };
      if (answer.defect_id && answer.answer_text) {
        input.answers.push(answer);
        let url = "/projects/inspection/" + this.$route.params.id;
        let response = await this.getHTTPPostResponse(
          url,
          input,
          "#save-answer",
          true
        );
        if (response) {
          this.getProject();
        }
      } else {
        this.displayError(
          "Please fill required details: Question No. " +
            question_details.question_number +
            "-" +
            question_details.question +
            "details"
        );
      }
    },

    // API Integration for Project Question Query Status
    async getProjectChangeQueryStatus(
      project_consultant_service_question_id,
      status
    ) {
      let input = {
        project_consultant_service_question_id,
        status,
      };
      let url = "/projects/change-query-status/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.getProject();
      }
    },
    getComments(qindex) {
      this.popupActive = true;

      this.selected_question_index = qindex;
      this.comments =
        this.filtered_questions[
          qindex
        ].project_consultant_service_question.comments;
    },
    // API Integration for Project Question Comments
    async addProjectQuestionComments() {
      let input = {
        project_consultant_service_question_id:
          this.filtered_questions[this.selected_question_index]
            .project_consultant_service_question.id,
        comment: this.comment,
      };
      let url = "/projects/comment/" + this.$route.params.id;
      let response = await this.getHTTPPostResponse(url, input, "", true);
      if (response) {
        this.comment = "";
        this.popupActive = false;
        this.getProject();
      }
    },
    // API Integration for getData
    async getProject() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/projects/get/" + this.$route.params.id
      );
      if (response) {
        let data = response.data;
        let project = data.project;
        this.project = data.project;
        this.vessel_type_id = project.vessel_type_id;
        this.sub_type_id = project.vessel_sub_type_id;

        this.raw_consultants = project.consultants;
        let consultants = project.consultants;

        let filteredConsultants = [];
        for (var i = 0; i < consultants.length; i++) {
          let obj = { id: consultants[i].id, name: consultants[i].name };
          filteredConsultants.push(obj);
        }
        this.consultants = filteredConsultants;
        /**
        Our dear one consultant, why so many loops are here ???
         */
        if (this.consultants.length === 1) {
          this.consultant = this.consultants[0].id;
          this.selected_con = this.consultants[0].id;

          let service_req = consultants[0].project_consultant.services;
          let filteredServices = [];
          for (var i = 0; i < service_req.length; i++) {
            let obj = { id: service_req[i].id, name: service_req[i].name };
            filteredServices.push(obj);
          }
          this.services_drop = filteredServices;
        }

        // Map
        setTimeout(() => {
          let consultant_services_data = [];
          consultants.forEach((consultant) => {
            var services = consultant.project_consultant.services;
            let ser_id = [];
            services = services.forEach((serve) => {
              let squestions = serve.project_consultant_service.questions;
              squestions.forEach((que) => {});
              let obj = {
                service_name: serve.name,
                service_id: serve.id,
                service_question: squestions,
              };
              ser_id.push(obj);
            });
            consultant_services_data.push({
              consultant_id: consultant.id,
              consultant_name: consultant.name,
              services: this.service,
              work_instructions_text:
                consultant.project_consultant.work_instructions_text,
              work_instructions_attachment:
                consultant.project_consultant.work_instructions_attachment,
              status: consultant.project_consultant.status_name,
              service_ids: ser_id,
            });
          });
          this.consultant_services_array = consultant_services_data;
        }, 100);
        // Maping for images (for answers)

        project.consultants.forEach((eachCon) => {
          eachCon.project_consultant.services.forEach((eachSer) => {
            let dataQuestion = eachSer.project_consultant_service.questions.map(
              function (app) {
                if (
                  app.project_consultant_service_question.images != null &&
                  app.project_consultant_service_question.images.length != 0
                ) {
                  let images = [];
                  app.project_consultant_service_question.images.forEach(
                    (element) => {
                      if (element != null) {
                        images.push({
                          path: element,
                          s3_url: element,
                        });
                      }
                    }
                  );
                  app.project_consultant_service_question.images = images;
                } else {
                  app.project_consultant_service_question.images = [];
                }
                return app;
              }
            );
            this.questions = project.consultants;
          });
        });
      }
      this.$vs.loading.close();
      this.isChanged = false;
    },
    // API Integration for section listing
    async getSections() {
      let input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/sections/list", input);
      if (response) {
        let sections = response.data.sections;
        let filteredSection = [];
        let first_obj = { id: 0, name: "All Sections" };
        filteredSection.push(first_obj);
        for (var i = 0; i < sections.length; i++) {
          var section = sections[i];
          let obj = {
            id: sections[i].id,
            name: sections[i].id + ". " + sections[i].name,
          };
          filteredSection.push(obj);
          if (section.children.length) {
            for (var j = 0; j < section.children.length; j++) {
              var sub_type = section.children[j];
              filteredSection.push({
                id: sub_type.id,
                name: "----- " + sub_type.id + ". " + sub_type.name,
              });
            }
          }
        }
        // }
        this.filterSection = filteredSection;
      }
    },
    // API Integration for Designations
    async getDesignations() {
      let input = {
        name: this.designation,
      };
      let response = await this.getHTTPPostResponse(
        "/designations/list",
        input
      );
      if (response) {
        let designation_req = response.data.designations;
        let filteredDesignations = [];
        let first_obj = { id: "", name: "All Designation" };
        filteredDesignations.push(first_obj);
        for (var i = 0; i < designation_req.length; i++) {
          let obj = {
            id: designation_req[i].id,
            name: designation_req[i].name,
          };
          filteredDesignations.push(obj);
        }
        this.filterDesignation = filteredDesignations;
      }
    },
    clearFilter() {
      this.designation = "";
      this.section = 0;
      this.query_status_filter = "";
      this.search = "";
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    clearFileName(qindex) {
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              el.project_consultant_service.questions[
                qindex
              ].project_consultant_service_question.answer_attachment = "";

              let id = "audio_control_exit" + qindex;
              document.getElementById(id).load();
            }
          });
        }
      });
    },
    async handleFiles(event, qindex) {
      // var files = event.target.files;
      // $("#audio_source" + index).attr("src", URL.createObjectURL(files[0]));
      // document.getElementById("audio_control" + index).load();
      let file = event.target.files[0];
      if (file.type !== "audio/mp3") {
        event.target.files[0].value = "";
      }
      // upload s3
      var input = new FormData();
      input.append("directory", "audio_file");
      input.append("attachment", file);
      let response = await this.getHTTPPostResponse(
        "/s3/upload",
        input,
        "",
        true
      );
      this.isChanged = true;
      let consultants = this.raw_consultants;
      let con_target = this.selected_con;
      let ser_target = this.selected_ser;
      consultants.forEach(function (el) {
        if (el.id == con_target) {
          el.project_consultant.services.forEach(function (el) {
            if (el.id == ser_target) {
              el.project_consultant_service.questions[
                qindex
              ].project_consultant_service_question.answer_attachment =
                response.data.url;

              let id = "audio_control" + qindex;
              document.getElementById(id).load();
            }
          });
        }
      });
    },
    // Images Logic
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadImageSuccess(forData, index, fileList) {
      let fileImage = this.dataURLtoFile(
        fileList[index].path,
        fileList[index].name
      );
      let flag = 1;
      if (
        fileImage.type === "image/png" ||
        fileImage.type === "image/jpeg" ||
        fileImage.type === "image/jpg"
      ) {
        flag = 1;
      } else {
        alert("Please upload image with extension .png ,.jpg, .jpeg");
        flag = 0;
        let consultants = this.raw_consultants;
        let con_target = this.selected_con;
        let ser_target = this.selected_ser;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      }
      if (fileImage.size > 10000000) {
        alert("Please upload under 10mb!");
        let consultants = this.raw_consultants;
        let con_target = this.selected_con;
        let ser_target = this.selected_ser;
        consultants.forEach(function (el) {
          el.project_consultant.services.forEach(function (el) {
            el.project_consultant_service.questions.forEach(function (el) {
              el.project_consultant_service_question.images.splice(index, 1);
            });
          });
        });
        return false;
      } else {
        var input = new FormData();
        input.append("directory", "listing");
        input.append("attachment", fileImage);
        this.axios
          .post("s3/upload", input)
          .then((response) => {
            let data = response.data.data;
            fileList[index].s3_url = data.url;
            this.isChanged = true;
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          })
          .catch((e) => {
            this.showError(e);
          });
      }
    },
    beforeRemove(index, done, fileList) {
      this.url = fileList[index].s3_url;
      this.index = index;
      this.remove_data = {
        index: index,
        done: done,
      };
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.delete"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.removeImage,
      });
    },
    removeImage() {
      let input = {
        url: this.url,
      };
      this.axios
        .post("s3/remove", input)
        .then((response) => {
          // show notification only
          // if new image is deleted.
          this.remove_data.done();
          if (!this.remove_data.edit) {
            this.$vs.notify({
              title: "Success.",
              text: response.data.message,
              color: "success",
              position: "top-right",
            });
          }
          return "tttttt";
        })
        .catch((e) => {
          this.images.splice(this.remove_data.index, 1);
          this.remove_data.done();
          this.showError(e);
        });
    },
    async printQuestions(exp) {
      let input = {
        consultant_id: this.selected_con,
        project_id: this.$route.params.id,
        is_guidance_required: 0,
        service_id: this.selected_ser,
      };
      if (exp) {
        input = Object.assign(input, {
          is_guidance_required: 1,
        });
      }
      this.axios
        .post("/projects/print-questions", input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          let name = "";
          if (exp) {
            name = this.project.name + "_with Guidance";
          } else {
            name = this.project.name + "_without Guidance";
          }
          this.exportPdfFile(data, name);
          this.export = 0;
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    // This function is called when we click on back button of page
    goBackConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: "Confirm",
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: "Are you sure you want leave without saving?",
        accept: this.cancle,
      });
    },
    detectChange() {
      this.isChanged = true;
    },
    // function to check all fields while preventing
    checkAllFields() {
      if (this.filtered_questions.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    // This function is called when we click on ok button of opened dialogue
    async cancle() {
      history.back();
    },
    // This function is called when we click on cancle button of opened dialogue or brwowser's reload of the page
    preventNav() {
      if (!this.checkAllFields()) {
        return;
      }
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    // This function is called when we click on back button of page and open new dialogue for confirmation
    goBack() {
      let flag = this.isChanged;
      if (flag) {
        if (this.goBackConfirm()) {
          this.preventNav;
          return;
        }
      } else {
        history.back();
      }
    },
    // goBack() {
    //   history.back();
    // }
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}

.question-feather {
  vertical-align: middle;
}

.label-center {
  align-self: center !important;
}

a,
a:hover {
  color: #626262;
  text-decoration: none;
}

.audio {
  -webkit-text-stroke-width: thin;
}

[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: rgba(var(--vs-dark), 1);
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Poppins", sans-serif;
  font-size: inherit;
  font-weight: 500;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  vertical-align: middle;
}

[type="file"] + label:hover {
  background-color: rgba(var(--vs-dark), 1);
}

[type="file"] + label.btn-1 {
  background-color: rgba(var(--vs-dark), 1);
  box-shadow: 0 6px #00449cd1;
  -webkit-transition: none;
  transition: none;
}

[type="file"] + label.btn-1:hover {
  box-shadow: 0 4px #00449cd1;
  top: 2px;
}

.service-border {
  border-bottom: 2px solid #f6f6f6;
}

.audio-file {
  align-items: flex-end;
}

.raise-question {
  position: absolute;
  right: 21px;
}

.comment-avatar {
  word-break: break-word;
}

.add-query {
  box-shadow: none !important;
  border: 1px solid #f1f1f1;
}

.submit-btn {
  text-align: center;
}

.header svg {
  width: 20px !important;
  height: 20px !important;
  color: rgba(var(--vs-dark), 1);
}

.external-link {
  color: rgba(var(--vs-danger), 1);
  /* float: left; */
}

.query-text .con-vs-chip {
  float: right !important;
}

.z-10 {
  z-index: 400 !important;
}

.card_position {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: -10px;
  margin-right: 80px;
  width: 31%;
  height: 109px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  float: left;
}

.card_position2 {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: -20px;
  margin-right: 25px;
  width: 31%;
  height: 109px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  float: left;
}

.card_position:first-child {
  grid-column: span 2;
  grid-row: span 2;
}

.questionary_position {
  box-sizing: border-box;
  width: 350px;
  height: 466px;
  padding: 30px;
  border: 1px solid lightgrey;
}

.safety_managemetnt {
  display: block;
  margin-top: -519px;
  margin-left: 450px;
}

.image_upload {
  margin-left: -41px;
  margin-right: 150px;
  justify-content: space-between;
  overflow: hidden;
}

.defeat_class {
  margin-left: 200px;
  /* margin-right: -350px; */
  width: 100%;
  display: flex;
  margin-top: -220px;
  justify-content: space-between;
  overflow: hidden;
}

.chat_raise_query {
  margin-top: 90px;
  overflow: hidden;
}

.decission {
  display: flex;
  margin-left: 321px;
  margin-top: -144px;
}

.audio_section {
  position: relative;
  margin-right: 400px;
}

.defect {
  margin-left: 750px;
  margin-top: -50px;
}

.save_button {
  position: absolute;
  margin-left: 300px;
  margin-top: 100px;
}

.collapse_btn {
  margin-left: 300px;
}

.sub_section {
  margin-left: 20px;
}

.question_position {
  margin-left: 25px;
}

.card {
  font-size: larger;
}

.collapse_position {
  margin-left: 260px;
}

.open {
}

.vs-content-sidebar {
  width: 100%;
  height: 100%;
}
</style>
